<script setup>
defineProps({
    value: String,

    isRequired: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <label class="block text-sm font-medium text-white">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>

        <span v-if="isRequired">
            <span class="pl-0.5 text-red-500">*</span>
        </span>
    </label>
</template>
